<template>
  <v-row :key="message.id" :class="message.type === 'question' ? 'rowQuestion' : 'rowReply'" justify="center" no-gutters
         row
         wrap>
    <v-col cols="12" lg="8" md="10" xl="6">
      <v-container>
        <v-row no-gutters>
          <v-col cols="12">
            <v-list-item :class="$vuetify.breakpoint.mdAndUp && 'py-4'" class="px-0">
              <v-list-item-avatar :color="message.type === 'question' ? 'rowReply' : 'rowQuestion'"
                                  :size="$vuetify.breakpoint.mdAndUp ? 44 : 36"
                                  class="elevation-3"
                                  rounded
                                  style="align-self: start">
                <v-icon v-if="message.type === 'reply'" :large="$vuetify.breakpoint.mdAndUp" color="accent2">mdi
                  mdi-robot-happy
                </v-icon>
                <v-icon v-if="message.type === 'question'" :large="$vuetify.breakpoint.mdAndUp" color="accent2">mdi
                  mdi-account
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <div>
                  <div v-if="!!message.message" class="body-1">
                    <marked-wrapper :content="message.message"/>
                  </div>
                  <div v-else class="body-1">
                    <v-skeleton-loader dark
                                       loading
                                       type="paragraph"></v-skeleton-loader>
                  </div>

                  <div v-if="message.type === 'reply' && $vuetify.breakpoint.smAndDown" class="pt-3 text-right">
                    <!--                    <v-btn color="accent2 darken-4" icon small tile @click="thumbsUp">-->
                    <!--                      <v-icon small>mdi mdi-thumb-up-outline</v-icon>-->
                    <!--                    </v-btn>-->
                    <!--                    <v-btn color="accent2 darken-4" icon small tile @click="thumbsDown">-->
                    <!--                      <v-icon small>mdi mdi-thumb-down-outline</v-icon>-->
                    <!--                    </v-btn>-->
                    <v-btn color="accent2 darken-4" icon small tile @click="copyReply">
                      <v-icon small>mdi mdi-content-copy</v-icon>
                    </v-btn>
                  </div>

                </div>
              </v-list-item-content>
              <v-list-item-action v-if="$vuetify.breakpoint.mdAndUp" class="flex-row" style="align-self: start">
                <template v-if="message.type === 'reply'">
                  <!--                  <v-btn class="mt-n2" color="accent2 darken-4" icon small tile @click="thumbsUp">-->
                  <!--                    <v-icon small>mdi mdi-thumb-up-outline</v-icon>-->
                  <!--                  </v-btn>-->
                  <!--                  <v-btn class="mt-n2" color="accent2 darken-4" icon small tile @click="thumbsDown">-->
                  <!--                    <v-icon small>mdi mdi-thumb-down-outline</v-icon>-->
                  <!--                  </v-btn>-->
                  <v-btn class="mt-n2" color="accent2 darken-4" icon small tile @click="copyReply">
                    <v-icon v-if="!replyCopied" small>mdi mdi-content-copy</v-icon>
                    <v-icon v-else small>mdi mdi-check</v-icon>
                  </v-btn>
                </template>
              </v-list-item-action>
            </v-list-item>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
</template>
<script>
import MarkedWrapper from "@/views/Chat/components/MarkedWrapper.vue";

export default {
  name: 'chat-message-item',
  components: {MarkedWrapper},
  props: {
    message: {}
  },
  data() {
    return {
      replyCopied: false,
    }
  },
  methods: {
    thumbsUp() {
      this.$emit('thumbsUp', this.message);
    },
    thumbsDown() {
      this.$emit('thumbsDown', this.message);
    },
    copyReply() {
      navigator.clipboard.writeText(this.message.message)
          .then(() => {
            this.replyCopied = true;
            setTimeout(() => {
              this.replyCopied = false;
            }, 1350);
          })
          .catch(err => {
            console.error('Could not copy text: ', err);
          });
    }
  },
}
</script>
